var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTripleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103,
    height: 80,
    viewBox: "0 0 103 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Shape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    clipPath: "url(#clip-Shape)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H101.5V18H18Z",
    fill: "#f9e11e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M21,27h80.5V45H39Z",
    fill: "#f9e11e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M43,54h58.5V72H61Z",
    fill: "#f9e11e"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleLine);
export default __webpack_public_path__ + "static/media/triple-line.054fc6135eb5b63629563d2d7f942d72.svg";
export { ForwardRef as ReactComponent };